import React, { Component } from 'react';
import { config } from '../Constants';
import helpers from '../Function';

//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { Doughnut, Bar, Pie } from 'react-chartjs-2';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import $ from "jquery";

export default class Dashboard extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            create_by: name,
            create_by_id: user_id,
            jwt: jwt,
            user_permission: user_permission,
            transAll: 0,
            callCenterAll: 0,
            appAll: 0,
            inProcess: 0,
            doneCase: 0,
            complaint: 0,
            service: 0,
            transAllService: 0,
            callCenterAllService: 0,
            appAllService: 0,
            inProcessService: 0,
            doneCaseService: 0,
            complaint: 0,
            service: 0,
            topComplaint: [{ value: 0, display: "-" }],
            topComplaint1: [{ value: 0, display: "-" }],
            topComplaint2: [{ value: 0, display: "-" }],
            topService: [{ value: 0, display: "-" }],
            topService1: [{ value: 0, display: "-" }],
            topService2: [{ value: 0, display: "-" }],
            topProject: [{ value: 0, display: "-" }],
            topProject1: [{ value: 0, display: "-" }],
            topProject2: [{ value: 0, display: "-" }],
            topProject2: [{ value: 0, display: "-" }],
            topProject21: [{ value: 0, display: "-" }],
            topProject22: [{ value: 0, display: "-" }],
            topOther: [{ value: 0, display: "-" }],
            topComplaintAll: [{ value: 0, display: "-" }],
            topComplaintAll1: [{ value: 0, display: "-" }],
            topComplaintAll2: [{ value: 0, display: "-" }],
            topServiceAll: [{ value: 0, display: "-" }],
            topServiceAll1: [{ value: 0, display: "-" }],
            topServiceAll2: [{ value: 0, display: "-" }],
            topOtherAll: [{ value: 0, display: "-" }],
            topProjectAll: [{ value: 0, display: "-" }],
            topProjectAll2: [{ value: 0, display: "-" }],
            topProjectAll21: [{ value: 0, display: "-" }],
            topProjectAll22: [{ value: 0, display: "-" }],
            location: [],
            ServiceIsOpen1: false,
            ServiceIsOpen2: false,
            ComplaintIsOpen: false,
            OtherIsOpen: false,
            ProjectIsOpen: false,
            ProjectIsOpen2: false,
            singlehouseIsOpen: false,
            townhomeIsOpen: false,
            homeofficeIsOpen: false,
            condoIsOpen: false,
            GroupsIsOpen: false,
            memberchannelIsOpen: false,
            memberapproveIsOpen: false,
            showHomecare: true,
            showJuristic: false,
            showPresale: false,
            showCallcenter: false,
            showMember: false,
            transAllJuritic: 0,
            juristicAll: 0,
            appAllJuristic: 0,
            inProcessJuristic: 0,
            doneCaseJuristic: 0,
            suggestionJuristic: 0,
            serviceCenterJuristic: 0,
            locationJuristic: [{ value: 0, display: "-" }],
            topServiceCenterJuristic: [{ value: 0, display: "-" }],
            topServiceCenterAllJuristic: [{ value: 0, display: "-" }],
            topSuggestionJuristic: [{ value: 0, display: "-" }],
            topSuggestionJuristic1: [{ value: 0, display: "-" }],
            topSuggestionJuristic2: [{ value: 0, display: "-" }],
            topSuggestionAllJuristic: [{ value: 0, display: "-" }],
            topSuggestionAllJuristic1: [{ value: 0, display: "-" }],
            topSuggestionAllJuristic2: [{ value: 0, display: "-" }],
            topProjectJuristic: [{ value: 0, display: "-" }],
            topProjectJuristic1: [{ value: 0, display: "-" }],
            topProjectJuristic2: [{ value: 0, display: "-" }],
            topProjectAllJuristic: [{ value: 0, display: "-" }],
            sugguestionIsOpen: false,
            servicecenterIsOpen: false,
            projectJuristicIsOpen: false,
            systemListIsOpen: false,
            memberprojectAllIsOpen: false,
            memberprojectHaveIsOpen: false,
            memberprojectDontIsOpen: false,
            systemAll: 0,
            systemList: [{ value: 0, display: "-" }],
            systemAll: 0,
            systemList: [],
            registerList: [],
            faveriteList: [],
            sreachList: [],
            singlehouseList: [],
            townhomeList: [],
            homeofficeList: [],
            condoList: [],
            memberchannelList: [],
            memberapproveList: [],
            memberprojectAllList: [],
            memberprojectHaveList: [],
            memberprojectDontList: [],
            GroupsList: [],
            GroupsCallCenterList: [],
            topProjectSum: 0,
            topProjectSum1: 0,
            topProjectSum2: 0,
            topProjectSum2: 0,
            topProjectSum21: 0,
            topProjectSum22: 0,
            sreachListSum: 0,
            singlehouseSum: 0,
            townhomeSum: 0,
            homeofficeSum: 0,
            condoSum: 0,
            memberChannelSum: 0,
            memberapproveSum: 0,
            memberprojectAll: 0,
            memberprojectHave: 0,
            memberprojectDont: 0,
            GroupsCallCenterSum: 0,
            countTopService: 0,
            countTopService1: 0,
            countTopService2: 0,
            CounttopComplaintAll: 0,
            CounttopComplaintAll1: 0,
            CounttopComplaintAll2: 0,
            topSuggestionAllJuristicSum: 0,
            topSuggestionAllJuristicSum1: 0,
            topSuggestionAllJuristicSum2: 0,
            topProjectAllJuristicSum: 0,
            topServiceCenterAllJuristicSum: 0,
            HtmlService: ``,
            HtmlServiceCallcenter: ``,
            HtmlServiceJuristics: ``,
            TextService: ``,
            ownerMember: 0,
            installMember: 0,
            liveMember: 0,
            renterMember: 0,
            TotalAllMember: 0,
            OwnerMemberCount: 0,
            LiveMemberCount: 0,
            matches: window.matchMedia("(min-width: 768px)").matches
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeService = this.closeService.bind(this);
        this.openService = this.openService.bind(this);

        this.closeComplaintCancel = this.closeComplaintCancel.bind(this);
        this.openComplaint = this.openComplaint.bind(this);

        this.closeOtherCancel = this.closeOtherCancel.bind(this);
        this.openOther = this.openOther.bind(this);

        this.closeProjectCancel = this.closeProjectCancel.bind(this);
        this.openProject = this.openProject.bind(this);
        this.closeProjectCancel2 = this.closeProjectCancel2.bind(this);
        this.openProject2 = this.openProject2.bind(this);
        this.openHomecare = this.openHomecare.bind(this);
        this.openJuristic = this.openJuristic.bind(this);
        this.openPresale = this.openPresale.bind(this);
        this.openCallcenter = this.openCallcenter.bind(this);
        this.openMember = this.openMember.bind(this);

        this.DatasetHomecare = this.DatasetHomecare.bind(this);
        this.DatasetCallcenter = this.DatasetCallcenter.bind(this)
        this.DatasetJuristic = this.DatasetJuristic.bind(this);
        this.openSugguestion = this.openSugguestion.bind(this);
        this.closeSugguestion = this.closeSugguestion.bind(this);
        this.openServiceCenter = this.openServiceCenter.bind(this);
        this.closeServicecenter = this.closeServicecenter.bind(this);
        this.openProjectJuristic = this.openProjectJuristic.bind(this);
        this.closeProjectJuristic = this.closeProjectJuristic.bind(this);
        this.DatasetPresale = this.DatasetPresale.bind(this);
        this.closeSearch = this.closeSearch.bind(this);
        this.sreachOpen = this.sreachOpen.bind(this);

        this.openPresale = this.openPresale.bind(this);

        this.singlehouseOpen = this.singlehouseOpen.bind(this);
        this.townhomeOpen = this.townhomeOpen.bind(this);
        this.homeofficeOpen = this.homeofficeOpen.bind(this);
        this.condoOpen = this.condoOpen.bind(this);
        this.GroupsOpen = this.GroupsOpen.bind(this);
        this.memberchannelOpen = this.memberchannelOpen.bind(this);
        this.memberapproveOpen = this.memberapproveOpen.bind(this);


        this.closeSinglehouse = this.closeSinglehouse.bind(this);
        this.closeTownhome = this.closeTownhome.bind(this);
        this.closeHomeoffice = this.closeHomeoffice.bind(this);
        this.closeCondo = this.closeCondo.bind(this);
        this.closeGroups = this.closeGroups.bind(this)
        this.closememberchannel = this.closememberchannel.bind(this);
        this.closememberapprove = this.closememberapprove.bind(this);

        this.systemListOpen = this.systemListOpen.bind(this);
        this.closeSystemList = this.closeSystemList.bind(this);

        this.memberprojectListAllOpen = this.memberprojectListAllOpen.bind(this);
        this.closememberprojectListAll = this.closememberprojectListAll.bind(this);
        this.memberprojectListDontOpen = this.memberprojectListDontOpen.bind(this);
        this.closememberprojectListDont = this.closememberprojectListDont.bind(this);
        this.memberprojectListHaveOpen = this.memberprojectListHaveOpen.bind(this);
        this.closememberprojectListHave = this.closememberprojectListHave.bind(this);

    }

    componentDidMount() {
        const handler = e => this.setState({ matches: e.matches });
        window.matchMedia("(min-width: 768px)").addListener(handler);

        // const scriptAdminlte = document.createElement("script");

        // scriptAdminlte.src = "dist/js/adminlte.min.js";
        // scriptAdminlte.async = true;
        // document.body.appendChild(scriptAdminlte);

        // const scriptDemo = document.createElement("script");

        // scriptDemo.src = "dist/js/demo.js";
        // scriptDemo.async = true;
        // document.body.appendChild(scriptDemo);

        // this.openHomecare()
    }

    openSugguestion(TextService, topSuggestionAllJuristic, topSuggestionAllJuristicSum) {
        this.setState({
            sugguestionIsOpen: true,
            TextService: TextService,
            topSuggestionAllJuristic: topSuggestionAllJuristic,
            topSuggestionAllJuristicSum: topSuggestionAllJuristicSum
        });
    }

    closeSugguestion() {
        this.setState({ sugguestionIsOpen: false });
    }

    openService(TextService, countTopService, topServiceAll) {
        this.setState({
            ServiceIsOpen1: true,
            TextService: TextService,
            countTopService: topServiceAll,
            topServiceAll: countTopService

        });
    }

    closeService() {
        this.setState({ ServiceIsOpen1: false });
    }

    openServiceCenter() {
        this.setState({ servicecenterIsOpen: true });
    }

    closeServicecenter() {
        this.setState({ servicecenterIsOpen: false });
    }

    openProjectJuristic() {
        this.setState({ projectJuristicIsOpen: true });
    }

    closeProjectJuristic() {
        this.setState({ projectJuristicIsOpen: false });
    }

    closeSearch() {
        this.setState({ searchIsOpen: false });
    }

    sreachOpen() {
        this.setState({ searchIsOpen: true });
    }

    closeComplaintCancel() {
        this.setState({ ComplaintIsOpen: false });
    }

    openComplaint(TextService, topComplaintAll, CountTopComplaintAll) {

        this.setState({ ProjectIsOpen: false });
        this.setState({ ProjectIsOpen2: false });
        this.setState({ ServiceIsOpen1: false });
        this.setState({ OtherIsOpen: false });
        this.setState({
            ComplaintIsOpen: true,
            TextService: TextService,
            CounttopComplaintAll: CountTopComplaintAll,
            topComplaintAll: topComplaintAll
        });
    }

    closeOtherCancel() {
        this.setState({ OtherIsOpen: false });
    }

    openOther() {
        this.setState({ ProjectIsOpen: false });
        this.setState({ ProjectIsOpen2: false });
        this.setState({ ServiceIsOpen1: false });
        this.setState({ ComplaintIsOpen: false });
        this.setState({ OtherIsOpen: true });
    }

    closeProjectCancel() {
        this.setState({ ProjectIsOpen: false });
    }

    openProject(TextService, topProjectAll, topProjectSum) {
        this.setState({ ServiceIsOpen1: false });
        this.setState({ ComplaintIsOpen: false });
        this.setState({ OtherIsOpen: false });
        this.setState({
            ProjectIsOpen: true,
            TextService: TextService,
            topProjectAll: topProjectAll,
            topProjectSum: topProjectSum
        });
        this.setState({ ProjectIsOpen2: false });
    }

    closeProjectCancel2() {
        this.setState({ ProjectIsOpen2: false });
    }

    openProject2(TextService, topProjectAll2, topProjectSum2) {

        this.setState({ ServiceIsOpen1: false });
        this.setState({ ComplaintIsOpen: false });
        this.setState({ OtherIsOpen: false });
        this.setState({ ProjectIsOpen: false });
        this.setState({
            ProjectIsOpen2: true,
            TextService: TextService,
            topProjectAll2: topProjectAll2,
            topProjectSum2: topProjectSum2
        });
    }

    DatasetPresale() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            //getdashboadlogin
            fetch(config.url.API_URL + '/getdashboadlogin', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sum = 0
                    var FromApi = data.data.map(datas => {
                        sum += datas.count
                        return { value: datas.count, display: helpers.getMemberType(datas._id) }
                    });
    
                    this.setState({
                        systemList: [].concat(FromApi),
                        systemAll: sum
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //getdashboadregister
            fetch(config.url.API_URL + '/getdashboadregister', requestOptions)
                .then(res => res.json())
                .then(data => {
    
                    var FromApi = data.data.map(datas => {
                        return { value: datas.count, display: datas._id }
                    });
    
                    //console.log(JSON.stringify(FromApi))
    
                    this.setState({
                        registerList: [].concat(FromApi),
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //getdashboadfaverite
            fetch(config.url.API_URL + '/getdashboadfaverite', requestOptions)
                .then(res => res.json())
                .then(data => {
    
                    var FromApi = data.data.map(datas => {
                        return { value: datas.count, display: datas._id }
                    });
    
                    this.setState({
                        faveriteList: [].concat(FromApi),
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //getdashboadsearch
            fetch(config.url.API_URL + '/getdashboadsearch', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sum = 0;
                    var FromApi = data.data.map(datas => {
                        sum += datas.count;
                        return { value: datas.count, display: datas._id }
                    });
    
                    this.setState({
                        sreachList: [].concat(FromApi),
                        sreachListSum: sum
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //getdashboadsinglehouse
            fetch(config.url.API_URL + '/getdashboadsinglehouse', requestOptions)
                .then(res => res.json())
                .then(data => {
                    //console.log(data.data)
                    var sum = 0;
                    var FromApi = data.data.map(datas => {
                        sum += datas.count;
                        return { value: datas.count, display: datas._id, count: datas.countData }
                    });
                    this.setState({
                        singlehouseList: [].concat(FromApi),
                        singlehouseSum: parseFloat(data.percent).toFixed(2),
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //getdashboadtownhome
            fetch(config.url.API_URL + '/getdashboadtownhome', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sum = 0;
                    var FromApi = data.data.map(datas => {
                        sum += datas.count;
                        return { value: datas.count, display: datas._id, count: datas.countData }
                    });
    
                    this.setState({
                        townhomeList: [].concat(FromApi),
                        townhomeSum: parseFloat(data.percent).toFixed(2),
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //getdashboadhomeoffice
            fetch(config.url.API_URL + '/getdashboadhomeoffice', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sum = 0;
                    var FromApi = data.data.map(datas => {
                        sum += datas.count;
                        return { value: datas.count, display: datas._id, count: datas.countData }
                    });
    
                    this.setState({
                        homeofficeList: [].concat(FromApi),
                        homeofficeSum: parseFloat(data.percent).toFixed(2),
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //getdashboadcondo
            fetch(config.url.API_URL + '/getdashboadcondo', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sum = 0;
                    var FromApi = data.data.map(datas => {
                        sum += datas.count;
                        return { value: datas.count, display: datas._id, count: datas.countData }
                    });
    
                    this.setState({
                        condoList: [].concat(FromApi),
                        condoSum: parseFloat(data.percent).toFixed(2),
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            fetch(config.url.API_URL + '/presale_trackings', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var DataFrom = data.data
                    this.setState({
                        location: [].concat(DataFrom)
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    DatasetJuristic() {
        try {
            var countHomecare = []
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/juristicdashboard', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var datas = data.data;
                    if (datas) {
                        this.setState({
                            transAllJuritic: datas.transAll,
                            juristicAll: datas.callCenterAll,
                            appAllJuristic: datas.appAll,
                            inProcessJuristic: datas.inProcess,
                            doneCaseJuristic: datas.doneCase,
                            suggestionJuristic: datas.suggestion !== "NaN" ? parseInt(datas.suggestion) : 0,
                            serviceCenterJuristic: datas.serviceCenter !== "NaN" ? parseInt(datas.serviceCenter) : 0,
                            //suggestionJuristic: 0,
                            //serviceCenterJuristic: 0,
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            fetch(config.url.API_URL + '/juristicgetdashboadsuggestion?limit=5', requestOptions)
                .then(res => res.json())
                .then(data => {
                    for (var index = 0; index < data.data.length; index++) {
                        countHomecare.push(data.data[index].name)
    
                        var FromService = data.data[index].data.map(datas => {
                            return { value: datas.count, display: datas._id }
                        });
    
                        this.setState({
                            ["topSuggestionJuristic" + (index + 1)]: [].concat(FromService)
                        });
                    }
    
                    fetch(config.url.API_URL + '/juristicgetdashboadsuggestion', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            for (var index = 0; index < data.data.length; index++) {
                                var sum = 0;
                                var FromService = data.data[index].data.map(datas => {
                                    sum += datas.count;
                                    return { value: datas.count, display: datas._id }
                                });
    
                                this.setState({
                                    ["topSuggestionAllJuristic" + (index + 1)]: [].concat(FromService),
                                    ["topSuggestionAllJuristicSum" + (index + 1)]: sum
                                });
    
                            }
                            fetch(config.url.API_URL + '/jusricticgetdashboadproject?limit=5', requestOptions)
                                .then(res => res.json())
                                .then(data => {
    
                                    for (var index = 0; index < data.data.length; index++) {
    
                                        var FromProject = data.data[index].data.map(datas => {
                                            return { value: datas.count, display: datas._id }
                                        });
    
                                        this.setState({
                                            ["topProjectJuristic" + (index + 1)]: [].concat(FromProject)
                                        });
    
                                    }
    
                                    fetch(config.url.API_URL + '/jusricticgetdashboadproject', requestOptions)
                                        .then(res => res.json())
                                        .then(data => {
    
                                            for (var index = 0; index < data.data.length; index++) {
    
                                                var sum = 0;
                                                var FromProject = data.data[index].data.map(datas => {
                                                    sum += datas.count;
                                                    return { value: datas.count, display: datas._id }
                                                });
                                                this.setState({
                                                    ["topProjectAllJuristic" + (index + 1)]: [].concat(FromProject),
                                                    ["topProjectAllJuristicSum" + (index + 1)]: sum
                                                });
    
                                            }
    
                                            this.renderHTMLJuristics(countHomecare)
                                        }).catch(error => {
                                            console.log(error)
                                            //window.location.reload(); // Reload the page
                                        });
                                }).catch(error => {
                                    console.log(error)
                                    //window.location.reload(); // Reload the page
                                });
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    DatasetHomecare() {
        try {
            var countHomecare = []
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/callcenterdashboard', requestOptions)
                .then(res => res.json())
                .then(data => {
    
                    var datas = data.data;
    
                    this.setState({
                        transAll: datas.transAll,
                        callCenterAll: datas.callCenterAll,
                        appAll: datas.appAll,
                        inProcess: datas.inProcess,
                        doneCase: datas.doneCase,
                        complaint: datas.complaint,
                        service: datas.service,
                    });
    
    
                    //homecare
                    fetch(config.url.API_URL + '/getdashboadservice', requestOptions)
                        .then(res => res.json())
                        .then(data => {
    
                            for (var index = 0; index < data.data.length; index++) {
                                var countTopService = data.data[index].data.reduce(function (tot, arr) {
                                    // return the sum with previous value
                                    return tot + arr.count;
    
                                    // set initial value as 0
                                }, 0);
    
                                var FromService = data.data[index].data.map(datas => {
                                    return { value: datas.count, display: datas._id }
                                });
    
                                this.setState({
                                    ["topServiceAll" + (index + 1)]: [].concat(FromService),
                                    ["countTopService" + (index + 1)]: countTopService
                                });
    
                            }
    
                            //homecare
                            fetch(config.url.API_URL + '/getdashboadservice?limit=5', requestOptions)
                                .then(res => res.json())
                                .then(data => {
    
                                    for (var index = 0; index < data.data.length; index++) {
                                        countHomecare.push(data.data[index].name)
    
                                        var FromService = data.data[index].data.map(datas => {
                                            return { value: datas.count, display: datas._id }
                                        });
    
                                        this.setState({
                                            ["topService" + (index + 1)]: [].concat(FromService)
                                        });
                                    }
    
    
                                    //homecare
                                    fetch(config.url.API_URL + '/getdashboadproject2?limit=5', requestOptions)
                                        .then(res => res.json())
                                        .then(data => {
    
                                            for (var index = 0; index < data.data.length; index++) {
    
                                                var FromProject = data.data[index].data.map(datas => {
                                                    return { value: datas.count, display: datas._id }
                                                });
    
                                                this.setState({
                                                    ["topProject2" + (index + 1)]: [].concat(FromProject)
                                                });
    
                                            }
    
                                            //homecare
                                            fetch(config.url.API_URL + '/getdashboadproject2', requestOptions)
                                                .then(res => res.json())
                                                .then(data => {
    
                                                    for (var index = 0; index < data.data.length; index++) {
    
                                                        var sum = 0;
                                                        var FromProject = data.data[index].data.map(datas => {
                                                            sum += datas.count;
                                                            return { value: datas.count, display: datas._id }
                                                        });
                                                        this.setState({
                                                            ["topProjectAll2" + (index + 1)]: [].concat(FromProject),
                                                            ["topProjectSum2" + (index + 1)]: sum
                                                        });
    
                                                    }
    
                                                    //homecare
                                                    fetch(config.url.API_URL + '/getdashboadhomecaregroupservice', requestOptions)
                                                        .then(res => res.json())
                                                        .then(data => {
                                                            //console.log(data.data)
                                                            var sum = 0;
                                                            var FromApi = data.data.map(datas => {
                                                                sum += datas.count;
                                                                return { value: datas.count, display: datas._id, count: datas.countData }
                                                            });
                                                            this.setState({
                                                                GroupsList: [].concat(FromApi),
                                                                GroupsSum: parseFloat(data.percent).toFixed(2),
                                                            });
    
                                                            this.renderHTML(countHomecare)
                                                        }).catch(error => {
                                                            console.log(error)
                                                            //window.location.reload(); // Reload the page
                                                        });
                                                }).catch(error => {
                                                    console.log(error)
                                                    //window.location.reload(); // Reload the page
                                                });
                                        }).catch(error => {
                                            console.log(error)
                                            //window.location.reload(); // Reload the page
                                        });
                                }).catch(error => {
                                    console.log(error)
                                    //window.location.reload(); // Reload the page
                                });
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    DatasetMember() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/memberdashboard', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var datas = data.data;
                    this.setState({
                        TotalAllMember: datas.TotalAllMember,
                        OwnerMemberCount: datas.OwnerMemberCount,
                        LiveMemberCount: datas.LiveMemberCount,
                        ownerMember: datas.ownerMember,
                        installMember: datas.installMember,
                        liveMember: datas.liveMember,
                        renterMember: datas.renterMember,
                    });
    
                    //getdashboadmemberchanel
                    fetch(config.url.API_URL + '/getdashboadmemberchanel', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            var sum = 0;
                            var FromApi = data.data.map(datas => {
                                sum += datas.count;
                                return { value: datas.count, display: datas._id, count: datas.countData }
                            });
    
                            this.setState({
                                memberchannelList: [].concat(FromApi),
                                memberChannelSum: parseFloat(data.percent).toFixed(2),
                            });
    
                            //getdashboadmemberapprove
                            fetch(config.url.API_URL + '/getdashboadmemberapprove', requestOptions)
                                .then(res => res.json())
                                .then(data => {
                                    var sum = 0;
                                    var FromApi = data.data.map(datas => {
                                        sum += datas.count;
                                        return { value: datas.count, display: datas._id, count: datas.countData }
                                    });
    
                                    this.setState({
                                        memberapproveList: [].concat(FromApi),
                                        memberapproveSum: parseFloat(data.percent).toFixed(2),
                                    });
    
                                    //getdashboadlogin
                                    fetch(config.url.API_URL + '/memberprojectdashboard?central_flag=3', requestOptions)
                                        .then(res => res.json())
                                        .then(data => {
    
                                            var sum = 0
                                            var FromApi = data.data.map(datas => {
                                                sum += datas.count
                                                return { value: datas.count, display: datas._id }
                                            });
    
                                            this.setState({
                                                memberprojectAllList: [].concat(FromApi),
                                                memberprojectAll: sum
                                            });
                                            fetch(config.url.API_URL + '/memberprojectdashboard?central_flag=0', requestOptions)
                                                .then(res => res.json())
                                                .then(data => {
    
                                                    var sum = 0
                                                    var FromApi = data.data.map(datas => {
                                                        sum += datas.count
                                                        return { value: datas.count, display: datas._id }
                                                    });
    
                                                    this.setState({
                                                        memberprojectDontList: [].concat(FromApi),
                                                        memberprojectDont: sum
                                                    });
                                                    fetch(config.url.API_URL + '/memberprojectdashboard?central_flag=1', requestOptions)
                                                        .then(res => res.json())
                                                        .then(data => {
    
                                                            var sum = 0
                                                            var FromApi = data.data.map(datas => {
                                                                sum += datas.count
                                                                return { value: datas.count, display: datas._id }
                                                            });
    
                                                            this.setState({
                                                                memberprojectHaveList: [].concat(FromApi),
                                                                memberprojectHave: sum
                                                            });
                                                        }).catch(error => {
                                                            console.log(error)
                                                            //window.location.reload(); // Reload the page
                                                        });
                                                }).catch(error => {
                                                    console.log(error)
                                                    //window.location.reload(); // Reload the page
                                                });
    
                                        }).catch(error => {
                                            console.log(error)
                                            //window.location.reload(); // Reload the page
                                        });
                                }).catch(error => {
                                    console.log(error)
                                    //window.location.reload(); // Reload the page
                                });
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    DatasetCallcenter() {
        try {
            var countHomecare = []
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/callcenterdashboard', requestOptions)
                .then(res => res.json())
                .then(data => {
    
                    var datas = data.data;
    
                    this.setState({
                        //callcenter
                        transAllService: datas.transAllService,
                        callCenterAllService: datas.callCenterAllService,
                        appAllService: datas.appAllService,
                        inProcess: datas.inProcess,
                        doneCase: datas.doneCase,
                        inProcessService: datas.inProcessService,
                        doneCaseService: datas.doneCaseService,
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //callcenter
            fetch(config.url.API_URL + '/getdashboadcomplaint?limit=5', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // var FromComplaint = data.data.map(datas => {
                    //     return { value: datas.count, display: datas._id }
                    // });
    
                    // this.setState({
                    //     topComplaint: [].concat(FromComplaint),
                    // });
    
                    for (var index = 0; index < data.data.length; index++) {
                        countHomecare.push(data.data[index].name)
    
                        var FromService = data.data[index].data.map(datas => {
                            return { value: datas.count, display: datas._id }
                        });
    
                        this.setState({
                            ["topComplaint" + (index + 1)]: [].concat(FromService)
                        });
                    }
    
                    //callcenter
                    fetch(config.url.API_URL + '/getdashboadcomplaint', requestOptions)
                        .then(res => res.json())
                        .then(data => {
    
                            for (var index = 0; index < data.data.length; index++) {
                                var countTopService = data.data[index].data.reduce(function (tot, arr) {
                                    // return the sum with previous value
                                    return tot + arr.count;
    
                                    // set initial value as 0
                                }, 0);
    
                                var FromService = data.data[index].data.map(datas => {
                                    return { value: datas.count, display: datas._id }
                                });
    
                                this.setState({
                                    ["topComplaintAll" + (index + 1)]: [].concat(FromService),
                                    ["CounttopComplaintAll" + (index + 1)]: countTopService
                                });
    
                            }
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            //callcenter
            fetch(config.url.API_URL + '/getdashboadproject?limit=5', requestOptions)
                .then(res => res.json())
                .then(data => {
    
                    for (var index = 0; index < data.data.length; index++) {
    
                        var FromProject = data.data[index].data.map(datas => {
                            return { value: datas.count, display: datas._id }
                        });
    
                        this.setState({
                            ["topProject" + (index + 1)]: [].concat(FromProject)
                        });
    
                    }
    
                    //callcenter
                    fetch(config.url.API_URL + '/getdashboadproject', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            for (var index = 0; index < data.data.length; index++) {
    
                                var sum = 0;
                                var FromProject = data.data[index].data.map(datas => {
                                    sum += datas.count;
                                    return { value: datas.count, display: datas._id }
                                });
                                this.setState({
                                    ["topProjectAll" + (index + 1)]: [].concat(FromProject),
                                    ["topProjectSum" + (index + 1)]: sum
                                });
    
                            }
    
                            //callcenter
                            fetch(config.url.API_URL + '/getdashboadcallcentergroupservice', requestOptions)
                                .then(res => res.json())
                                .then(data => {
                                    //console.log(data.data)
                                    var sum = 0;
                                    var FromApi = data.data.map(datas => {
                                        sum += datas.count;
                                        return { value: datas.count, display: datas._id, count: datas.countData }
                                    });
                                    this.setState({
                                        GroupsCallCenterList: [].concat(FromApi),
                                        GroupsCallCenterSum: parseFloat(data.percent).toFixed(2),
                                    });
    
                                    this.renderHTMLCallcenter(countHomecare)
                                }).catch(error => {
                                    console.log(error)
                                    //window.location.reload(); // Reload the page
                                });
                        })
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    componentDidMount() {
        console.log("============config.url.API_URL=====================" + config.url.API_URL)
        helpers.checklogin(this.state.jwt);
        this.DatasetHomecare()
        this.DatasetCallcenter()
        this.DatasetJuristic()
        this.DatasetPresale()
        this.DatasetMember()

        this.openJuristic()
    }

    openHomecare() {
        $("#btn-homecare").addClass("active")
        $("#btn-juristic").removeClass("active")
        $("#btn-presale").removeClass("active")
        $("#btn-callcenter").removeClass("active")
        $("#btn-member").removeClass("active")
        this.setState({
            showHomecare: true,
            showMember: false,
            showJuristic: false,
            showPresale: false,
            showCallcenter: false
        })
    }

    openCallcenter() {
        $("#btn-callcenter").addClass("active")
        $("#btn-homecare").removeClass("active")
        $("#btn-juristic").removeClass("active")
        $("#btn-presale").removeClass("active")
        $("#btn-member").removeClass("active")
        this.setState({
            showCallcenter: true,
            showHomecare: false,
            showJuristic: false,
            showPresale: false,
            showMember: false,
        })
    }

    openJuristic() {
        $("#btn-homecare").removeClass("active")
        $("#btn-juristic").addClass("active")
        $("#btn-presale").removeClass("active")
        $("#btn-callcenter").removeClass("active")
        $("#btn-member").removeClass("active")
        this.setState({
            showJuristic: true,
            showHomecare: false,
            showPresale: false,
            showCallcenter: false,
            showMember: false,
        })
    }

    openPresale() {
        $("#btn-homecare").removeClass("active")
        $("#btn-juristic").removeClass("active")
        $("#btn-presale").addClass("active")
        $("#btn-callcenter").removeClass("active")
        $("#btn-member").removeClass("active")
        this.setState({
            showPresale: true,
            showHomecare: false,
            showJuristic: false,
            showCallcenter: false,
            showMember: false,
        })
    }

    openMember() {
        $("#btn-homecare").removeClass("active")
        $("#btn-juristic").removeClass("active")
        $("#btn-presale").removeClass("active")
        $("#btn-member").addClass("active")
        $("#btn-callcenter").removeClass("active")
        this.setState({
            showMember: true,
            showHomecare: false,
            showJuristic: false,
            showPresale: false,
            showCallcenter: false,
        })
    }

    singlehouseOpen() {
        this.setState({ singlehouseIsOpen: true });
    }

    townhomeOpen() {
        this.setState({ townhomeIsOpen: true });
    }

    memberchannelOpen() {
        this.setState({ memberchannelIsOpen: true });
    }

    memberapproveOpen() {
        this.setState({ memberapproveIsOpen: true });
    }

    homeofficeOpen() {
        this.setState({ homeofficeIsOpen: true });
    }

    condoOpen() {
        this.setState({ condoIsOpen: true });
    }

    GroupsOpen() {
        this.setState({ GroupsIsOpen: true });
    }

    closeSinglehouse() {
        this.setState({ singlehouseIsOpen: false });
    }

    closeTownhome() {
        this.setState({ townhomeIsOpen: false });
    }

    closeHomeoffice() {
        this.setState({ homeofficeIsOpen: false });
    }

    closeCondo() {
        this.setState({ condoIsOpen: false });
    }

    closeGroups() {
        this.setState({ GroupsIsOpen: false });
    }

    closememberchannel() {
        this.setState({ memberchannelIsOpen: false });
    }

    closememberapprove() {
        this.setState({ memberapproveIsOpen: false });
    }

    systemListOpen() {
        this.setState({ systemListIsOpen: true });
    }

    closeSystemList() {
        this.setState({ systemListIsOpen: false });
    }

    memberprojectListAllOpen() {
        this.setState({ memberprojectAllIsOpen: true });
    }

    closememberprojectListAll() {
        this.setState({ memberprojectAllIsOpen: false });
    }

    memberprojectListDontOpen() {
        this.setState({ memberprojectDontIsOpen: true });
    }

    closememberprojectListDont() {
        this.setState({ memberprojectDontIsOpen: false });
    }

    memberprojectListHaveOpen() {
        this.setState({ memberprojectHaveIsOpen: true });
    }

    closememberprojectListHave() {
        this.setState({ memberprojectHaveIsOpen: false });
    }

    renderHTML(countHomecare) {
        var indents = [];
        for (let index = 0; index < countHomecare.length; index++) {
            if (this.state["topService" + (index + 1)].length > 0) {
                indents.push((
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                    <h5 className="card-title"><img src="dist/img/icon/ic_complaint_top02.png" className="card-icon" />{countHomecare[index]}</h5>
                                    <div className="card-tools">
                                        <span style={{ cursor: 'Pointer' }} onClick={() => this.openService(countHomecare[index], this.state["topServiceAll" + (index + 1)], this.state["countTopService" + (index + 1)])}>อ่านทั้งหมด</span>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <div className="table-responsive">
                                                <table className="table no-margin table-chart">
                                                    <tbody>
                                                        {
                                                            this.state["topService" + (index + 1)].map((datas, i) =>
                                                                <tr key={i}>
                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                    <td colSpan={2}>{datas.display}</td>
                                                                    <td className="text-right">{datas.value}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                    <h5 className="card-title"><img src="dist/img/icon/ic_search_top.png" className="card-icon" />โครงการที่{countHomecare[index]}</h5>
                                    <div className="card-tools">
                                        <span style={{ cursor: 'Pointer' }} onClick={() => this.openProject2(countHomecare[index], this.state["topProjectAll2" + (index + 1)], this.state["topProjectSum2" + (index + 1)])} >อ่านทั้งหมด</span>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <div className="table-responsive">
                                                <table className="table no-margin table-chart">
                                                    <tbody>
                                                        {
                                                            this.state["topProject2" + (index + 1)].map((datas, i) =>
                                                                <tr key={i}>
                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                    <td colSpan={2}>{datas.display}</td>
                                                                    <td className="text-right">{datas.value}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        }
        this.setState({ HtmlService: indents });
    }

    renderHTMLCallcenter(countHomecare) {
        var indents = [];
        for (let index = 0; index < countHomecare.length; index++) {
            if (this.state["topComplaint" + (index + 1)].length > 0) {
                indents.push((
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                    <h5 className="card-title"><img src="dist/img/icon/ic_complaint_top02.png" className="card-icon" />{countHomecare[index]}</h5>
                                    <div className="card-tools">
                                        <span style={{ cursor: 'Pointer' }} onClick={() => this.openComplaint(countHomecare[index], this.state["topComplaintAll" + (index + 1)], this.state["CounttopComplaintAll" + (index + 1)])}>อ่านทั้งหมด</span>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <div className="table-responsive">
                                                <table className="table no-margin table-chart">
                                                    <tbody>
                                                        {
                                                            this.state["topComplaint" + (index + 1)].map((datas, i) =>
                                                                <tr key={i}>
                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                    <td colSpan={2}>{datas.display}</td>
                                                                    <td className="text-right">{datas.value}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                    <h5 className="card-title"><img src="dist/img/icon/ic_search_top.png" className="card-icon" />โครงการที่{countHomecare[index]}</h5>
                                    <div className="card-tools">
                                        <span style={{ cursor: 'Pointer' }} onClick={() => this.openProject(countHomecare[index], this.state["topProjectAll" + (index + 1)], this.state["topProjectSum" + (index + 1)])}  >อ่านทั้งหมด</span>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <div className="table-responsive">
                                                <table className="table no-margin table-chart">
                                                    <tbody>
                                                        {
                                                            this.state["topProject" + (index + 1)].map((datas, i) =>
                                                                <tr key={i}>
                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                    <td colSpan={2}>{datas.display}</td>
                                                                    <td className="text-right">{datas.value}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        }
        this.setState({ HtmlServiceCallcenter: indents });
    }

    renderHTMLJuristics(countHomecare) {
        var indents = [];
        for (let index = 0; index < countHomecare.length; index++) {
            if (this.state["topSuggestionJuristic" + (index + 1)].length > 0) {
                indents.push((
                    <div className="row" key={index}>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                    <h5 className="card-title"><img src="dist/img/icon/ic_complaint_top02.png" className="card-icon" alt='' />{countHomecare[index]}</h5>
                                    <div className="card-tools">
                                        <span style={{ cursor: 'Pointer' }} onClick={() => this.openSugguestion(countHomecare[index], this.state["topSuggestionAllJuristic" + (index + 1)], this.state["topSuggestionAllJuristicSum" + (index + 1)])}>อ่านทั้งหมด</span>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <div className="table-responsive">
                                                <table className="table no-margin table-chart">
                                                    <tbody>
                                                        {
                                                            this.state["topSuggestionJuristic" + (index + 1)].map((datas, i) =>
                                                                <tr key={i}>
                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                    <td colSpan={2}>{datas.display}</td>
                                                                    <td className="text-right">{datas.value}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                    <h5 className="card-title"><img src="dist/img/icon/ic_search_top.png" className="card-icon" alt='' />โครงการที่{countHomecare[index]}</h5>
                                    <div className="card-tools">
                                        <span style={{ cursor: 'Pointer' }} onClick={() => this.openProject(countHomecare[index], this.state["topProjectAllJuristic" + (index + 1)], this.state["topProjectAllJuristicSum" + (index + 1)])}  >อ่านทั้งหมด</span>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <div className="table-responsive">
                                                <table className="table no-margin table-chart">
                                                    <tbody>
                                                        {
                                                            this.state["topProjectJuristic" + (index + 1)].map((datas, i) =>
                                                                <tr key={i}>
                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                    <td colSpan={2}>{datas.display}</td>
                                                                    <td className="text-right">{datas.value}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        }
        this.setState({ HtmlServiceJuristics: indents });
    }

    render() {

        const claimChart = {
            labels: [
                'ข้อเสนอแนะทั่วไป',
                'แจ้งซ่อม',
            ],
            datasets: [
                {
                    data: [this.state.complaint, this.state.service],
                    backgroundColor: ['#fd7e14', '#28a745'],
                }
            ]
        }

        const claimChartJuristic = {
            labels: [
                'ข้อเสนอแนะ',
                'แจ้งซ่อมส่วนกลาง',
            ],
            datasets: [
                {
                    data: [this.state.suggestionJuristic, this.state.serviceCenterJuristic],
                    backgroundColor: ['#fd7e14', '#28a745'],
                }
            ]
        }

        var color = ['#fd7e14', '#28a745', '#17a2b8', '#dc3545', '#cd0bcf', '#830bcf', '#cfc80b', '#1b04c5'
            , '#E6B0AA', '#D7BDE2', '#A9CCE3', '#A3E4D7', '#F9E79F', '#FAD7A0', '#E59866', '#2fb2af', '#00b036'
            , '#7b5e20', '#866d06', '#d93853', '#e29556', '#455965', '#81e611', '#4b0e70', '#a6ae33', '#e074b7'
            , '#aa0e7b', '#b476e7', '#518f8f', '#bc4943', '#d1aab5', '#2a348b', '#625196', '#272c3c', '#22c7f3'
            , '#e1b763', '#2a3d0f', '#e4422f', '#6fedc9', '#6794cc', '#bc00ac', '#71d4a3', '#c499ca', '#cdbb45'
            , '#746ff7', '#160e04', '#e307c0', '#2fae3b', '#8b064b', '#74156b', '#c6492f', '#056149', '#81d1ad'
            , '#621718', '#93176d', '#d90d7f', '#f78c62', '#41692e', '#116ac0', '#ec6ca3', '#651698', '#821611']

        var labelSigleHouse = (this.state.singlehouseList ? this.state.singlehouseList.map(data => {
            return data.display
        }) : [])

        var dataSigleHouse = (this.state.singlehouseList ? this.state.singlehouseList.map(data => {
            return data.value
        }) : [])

        var colorSigleHouse = (this.state.singlehouseList ? this.state.singlehouseList.map((data, key) => {
            return color[key]
        }) : [])

        //console.log("----------***+++--------------" + JSON.stringify(labelSigleHouse))

        const claimChartSigleHouse = {
            labels: labelSigleHouse,
            datasets: [
                {
                    data: dataSigleHouse,
                    backgroundColor: colorSigleHouse,
                }
            ]
        }

        var labeltownhome = (this.state.townhomeList ? this.state.townhomeList.map(data => {
            return data.display
        }) : [])

        var datatownhome = (this.state.townhomeList ? this.state.townhomeList.map(data => {
            return data.value
        }) : [])

        var colortownhome = (this.state.townhomeList ? this.state.townhomeList.map((data, key) => {
            return color[key]
        }) : [])

        const claimCharttownhome = {
            labels: labeltownhome,
            datasets: [
                {
                    data: datatownhome,
                    backgroundColor: colortownhome,
                }
            ]
        }

        var labelhomeoffice = (this.state.homeofficeList ? this.state.homeofficeList.map(data => {
            return data.display
        }) : [])

        var datahomeoffice = (this.state.homeofficeList ? this.state.homeofficeList.map(data => {
            return data.value
        }) : [])

        var colorhomeoffice = (this.state.homeofficeList ? this.state.homeofficeList.map((data, key) => {
            return color[key]
        }) : [])

        const claimCharthomeoffice = {
            labels: labelhomeoffice,
            datasets: [
                {
                    data: datahomeoffice,
                    backgroundColor: colorhomeoffice,
                }
            ]
        }

        var labelcondo = (this.state.condoList ? this.state.condoList.map(data => {
            return data.display
        }) : [])

        var datacondo = (this.state.condoList ? this.state.condoList.map(data => {
            return data.value
        }) : [])

        var colorcondo = (this.state.condoList ? this.state.condoList.map((data, key) => {
            return color[key]
        }) : [])

        const claimChartcondo = {
            labels: labelcondo,
            datasets: [
                {
                    data: datacondo,
                    backgroundColor: colorcondo,
                }
            ]
        }

        var labelGroups = (this.state.GroupsList ? this.state.GroupsList.map(data => {
            return data.display
        }) : [])

        var dataGroups = (this.state.GroupsList ? this.state.GroupsList.map(data => {
            return data.value
        }) : [])

        var colorGroups = (this.state.GroupsList ? this.state.GroupsList.map((data, key) => {
            return color[key]
        }) : [])

        const claimChartGroups = {
            labels: labelGroups,
            datasets: [
                {
                    data: dataGroups,
                    backgroundColor: colorGroups,
                }
            ]
        }

        var labelGroupsCallCenter = (this.state.GroupsCallCenterList ? this.state.GroupsCallCenterList.map(data => {
            return data.display
        }) : [])

        var dataGroupsCallCenter = (this.state.GroupsCallCenterList ? this.state.GroupsCallCenterList.map(data => {
            return data.value
        }) : [])

        var colorGroupsCallCenter = (this.state.GroupsCallCenterList ? this.state.GroupsCallCenterList.map((data, key) => {
            return color[key]
        }) : [])

        var labelmemberchannel = (this.state.memberchannelList ? this.state.memberchannelList.map(data => {
            return data.display
        }) : [])

        var datamemberchannel = (this.state.memberchannelList ? this.state.memberchannelList.map(data => {
            return data.value
        }) : [])

        var colormemberchannel = (this.state.memberchannelList ? this.state.memberchannelList.map((data, key) => {
            return color[key]
        }) : [])

        const claimChartmemberchannel = {
            labels: labelmemberchannel,
            datasets: [
                {
                    data: datamemberchannel,
                    backgroundColor: colormemberchannel,
                }
            ]
        }

        var labelmemberapprove = (this.state.memberapproveList ? this.state.memberapproveList.map(data => {
            return data.display
        }) : [])

        var datamemberapprove = (this.state.memberapproveList ? this.state.memberapproveList.map(data => {
            return data.value
        }) : [])

        var colormemberapprove = (this.state.memberapproveList ? this.state.memberapproveList.map((data, key) => {
            return color[key]
        }) : [])

        const claimChartmemberapprove = {
            labels: labelmemberapprove,
            datasets: [
                {
                    data: datamemberapprove,
                    backgroundColor: colormemberapprove,
                }
            ]
        }

        const claimChartGroupsCallCenter = {
            labels: labelGroupsCallCenter,
            datasets: [
                {
                    data: dataGroupsCallCenter,
                    backgroundColor: colorGroupsCallCenter,
                }
            ]
        }

        const donutOptions = {
            responsive: true,
            maintainAspectRatio: false,
            cutoutPercentage: 65,
            legend: {
                display: false
            },
            plugins: {
                labels: {
                    render: 'value',
                    fontSize: 0,
                }
            }
        }

        const pieOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            }
        }

        var lablesBar = this.state.location.map(datas => {
            return datas.display;
        });
        var maxBar = 0;
        var dataBar = this.state.location.map(datas => {

            if (datas.value > maxBar) {
                maxBar = datas.value;
            }

            return datas.value;
        });

        const locationBar = {
            labels: [].concat(lablesBar),
            datasets: [
                {
                    data: [].concat(dataBar),
                    backgroundColor: ['#3DCCD8', '#73B658', '#E58748', '#BE3B58', '#CA9D46']
                },
            ]
        }

        const locationOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
                position: 'bottom'
            },
            plugins: {
                labels: {
                    render: 'value'
                }
            },
            scales: {
                xAxes: [{
                    stacked: true,
                    barThickness: 35,
                }],
                yAxes: [{
                    stacked: true,
                    ticks: {
                        min: 0,
                        max: maxBar + 5,
                        stepSize: (maxBar + 5) / 2
                    }
                }]
            }
        }

        var lablesBar = this.state.registerList.map(datas => {
            return datas.display;
        });

        var maxBar = 0;

        var dataBar = this.state.registerList.map(datas => {

            if (datas.value > maxBar) {
                maxBar = datas.value;
            }

            return datas.value;
        });

        const registerBar = {
            labels: [].concat(lablesBar),
            datasets: [
                {
                    data: [].concat(dataBar),
                    backgroundColor: ['#3DCCD8', '#73B658', '#E58748', '#BE3B58', '#CA9D46']
                },
            ]
        }

        const registerOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
                position: 'bottom'
            },
            plugins: {
                labels: {
                    render: 'value'
                }
            },
            scales: {
                xAxes: [{
                    stacked: true,
                    barThickness: 35,
                }],
                yAxes: [{
                    stacked: true,
                    ticks: {
                        min: 0,
                        max: maxBar + 5,
                        stepSize: (maxBar + 5) / 2
                    }
                }]
            }
        }

        var lablesBar = this.state.faveriteList.map(datas => {
            return datas.display;
        });

        var maxBar = 0;

        var dataBar = this.state.faveriteList.map(datas => {

            if (datas.value > maxBar) {
                maxBar = datas.value;
            }

            return datas.value;
        });

        const faveriteBar = {
            labels: [].concat(lablesBar),
            datasets: [
                {
                    data: [].concat(dataBar),
                    backgroundColor: ['#3DCCD8', '#73B658', '#E58748', '#BE3B58', '#CA9D46']
                },
            ]
        }

        const faveriteOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
                position: 'bottom'
            },
            plugins: {
                labels: {
                    render: 'value'
                }
            },
            scales: {
                xAxes: [{
                    stacked: true,
                    barThickness: 35,
                }],
                yAxes: [{
                    stacked: true,
                    ticks: {
                        min: 0,
                        max: maxBar + 5,
                        stepSize: (maxBar + 5) / 2
                    }
                }]
            }
        }

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Dashboard</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item active"></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        {/* Info boxes */}
                        {!this.state.matches && (<div>
                            <div className="row">
                                {(this.state.user_permission[196].permission == 1 &&
                                    <div className="col-3 col-sm-3 col-md-3">
                                        <div className="info-box" id="btn-member">
                                            <button className="info-box-content btn" onClick={this.openMember} style={{ fontSize: "20px", padding: 0 }}>Member</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[0].permission == 1 &&
                                    <div className="col-3 col-sm-3 col-md-3">
                                        <div className="info-box" id="btn-presale">
                                            <button className="info-box-content btn" onClick={this.openPresale} style={{ fontSize: "20px", padding: 0 }}>Presale</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[2].permission == 1 &&
                                    <div className="col-3 col-sm-3 col-md-3">
                                        <div className="info-box active" id="btn-juristic">
                                            <button className="info-box-content btn" onClick={this.openJuristic} style={{ fontSize: "20px", padding: 0 }}>Juristic</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[1].permission == 1 &&
                                    <div className="col-3 col-sm-3 col-md-3">
                                        <div className="info-box" id="btn-homecare">
                                            <button className="info-box-content btn" onClick={this.openHomecare} style={{ fontSize: "20px", padding: 0 }}>Homecare</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[196].permission == 1 &&
                                    <div className="col-3 col-sm-3 col-md-3">
                                        <div className="info-box" id="btn-callcenter">
                                            <button className="info-box-content btn" onClick={this.openCallcenter} style={{ fontSize: "18px", padding: 0 }}>Call Center</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>)}
                        {this.state.matches && (<div>
                            <div className="row">
                                {(this.state.user_permission[196].permission == 1 &&
                                    <div className="col-2 col-sm-2 col-md-2">
                                        <div className="info-box" id="btn-member">
                                            <button className="info-box-content btn" onClick={this.openMember} style={{ fontSize: "20px", padding: 0 }}>Member</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[0].permission == 1 &&
                                    <div className="col-2 col-sm-2 col-md-2">
                                        <div className="info-box" id="btn-presale">
                                            <button className="info-box-content btn" onClick={this.openPresale} style={{ fontSize: "20px", padding: 0 }}>Presale</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[2].permission == 1 &&
                                    <div className="col-2 col-sm-2 col-md-2">
                                        <div className="info-box active" id="btn-juristic">
                                            <button className="info-box-content btn" onClick={this.openJuristic} style={{ fontSize: "20px", padding: 0 }}>Juristic</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[1].permission == 1 &&
                                    <div className="col-2 col-sm-2 col-md-2">
                                        <div className="info-box" id="btn-homecare">
                                            <button className="info-box-content btn" onClick={this.openHomecare} style={{ fontSize: "20px", padding: 0 }}>Homecare</button>
                                        </div>
                                    </div>
                                )}

                                {(this.state.user_permission[196].permission == 1 &&
                                    <div className="col-2 col-sm-2 col-md-2">
                                        <div className="info-box" id="btn-callcenter">
                                            <button className="info-box-content btn" onClick={this.openCallcenter} style={{ fontSize: "18px", padding: 0 }}>Call Center</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>)}
                        {this.state.showHomecare &&
                            <div className="row" >
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_transaction.png" className="card-icon" />Transaction</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.transAll} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">Call Center</div>
                                                                <h2 className="text-highlight">{this.state.callCenterAll}</h2>
                                                                <span className="text-unit">รายการ</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">App</div>
                                                                <h2 className="text-highlight">{this.state.appAll}</h2>
                                                                <span className="text-unit">รายการ</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_allcase.png" className="card-icon" />All Case</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.transAll} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">In Process</div>
                                                                <h2 className="text-highlight">{this.state.inProcess}</h2>
                                                                <span className="text-unit">Case</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">Done Case</div>
                                                                <h2 className="text-highlight">{this.state.doneCase}</h2>
                                                                <span className="text-unit">Case</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        {this.state.HtmlService}
                                    </div>

                                </div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="card-header" style={{ borderBottom: 'none' }}>
                                            <h5 className="card-title" style={{ fontSize: '25px' }}>กลุ่มของเรื่องแจ้งซ่อม</h5>
                                            <div className="card-tools">
                                                <span onClick={this.GroupsOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                            </div>
                                        </div>
                                        <div className="card-body" style={{ padding: 0, height: "430px" }}>
                                            <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                {this.state.GroupsList.map((data, key) => {
                                                    return <div className="col-sm-6 col-6">
                                                        <div className="text-center">
                                                            <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                                }
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-12 col-12">
                                                    <div className="relative" style={{ marginTop: "50px" }}>
                                                        <Doughnut data={claimChartGroups} options={donutOptions} width={500} height={300} />
                                                        <div className="absolute-center text-center">แจ้งซ่อม</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ||
                            this.state.showCallcenter &&
                            <div className="row" >
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_transaction.png" className="card-icon" />Transaction</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.transAllService} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">Call Center</div>
                                                                <h2 className="text-highlight">{this.state.callCenterAllService}</h2>
                                                                <span className="text-unit">รายการ</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">App</div>
                                                                <h2 className="text-highlight">{this.state.appAllService}</h2>
                                                                <span className="text-unit">รายการ</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_allcase.png" className="card-icon" />All Case</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.transAllService} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">In Process</div>
                                                                <h2 className="text-highlight">{this.state.inProcessService}</h2>
                                                                <span className="text-unit">Case</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">Done Case</div>
                                                                <h2 className="text-highlight">{this.state.doneCaseService}</h2>
                                                                <span className="text-unit">Case</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {this.state.HtmlServiceCallcenter}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="card-header" style={{ borderBottom: 'none' }}>
                                            <h5 className="card-title" style={{ fontSize: '25px' }}>กลุ่มของข้อเสนอแนะทั่วไป</h5>
                                            <div className="card-tools">
                                                <span onClick={this.GroupsOpen} style={{ cursor: 'Pointer' }}>อ่านทั้งหมด</span>
                                            </div>
                                        </div>
                                        <div className="card-body" style={{ padding: 0, height: "430px" }}>
                                            <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                {this.state.GroupsList.map((data, key) => {
                                                    return <div className="col-sm-6 col-6">
                                                        <div className="text-center">
                                                            <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}
                                                            </div>
                                                        </div>
                                                        {/* /.description-block */}
                                                    </div>
                                                })
                                                }
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-12 col-12">
                                                    <div className="relative" style={{ marginTop: "50px" }}>
                                                        {/*<canvas id="claimChart" width={500} height={300} />*/}
                                                        <Doughnut data={claimChartGroupsCallCenter} options={donutOptions} width={500} height={300} />
                                                        <div className="absolute-center text-center">ข้อเสนอแนะทั่วไป</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    {/* /จบเนื้อหา */}
                                </div>
                            </div>
                            ||
                            this.state.showJuristic &&
                            <div className="row" >
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_transaction.png" className="card-icon" />Transaction</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.transAllJuritic} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">

                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">Call Center</div>
                                                                <h2 className="text-highlight">{this.state.juristicAll}</h2>
                                                                <span className="text-unit">รายการ</span>
                                                            </div>
                                                            {/* /.description-block */}
                                                        </div>

                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">App</div>
                                                                <h2 className="text-highlight">{this.state.appAllJuristic}</h2>
                                                                <span className="text-unit">รายการ</span>
                                                            </div>
                                                            {/* /.description-block */}
                                                        </div>
                                                    </div>

                                                </div>
                                                {/* /.card-footer */}
                                            </div>
                                            {/* /.card */}
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_allcase.png" className="card-icon" />All Case</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.transAllJuritic} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">

                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">In Process</div>
                                                                <h2 className="text-highlight">{this.state.inProcessJuristic}</h2>
                                                                <span className="text-unit">Case</span>
                                                            </div>
                                                            {/* /.description-block */}
                                                        </div>

                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">Done Case</div>
                                                                <h2 className="text-highlight">{this.state.doneCaseJuristic}</h2>
                                                                <span className="text-unit">Case</span>
                                                            </div>
                                                            {/* /.description-block */}
                                                        </div>
                                                    </div>

                                                </div>
                                                {/* /.card-footer */}
                                            </div>
                                            {/* /.card */}
                                        </div>

                                    </div>
                                    {/* ตรงนี้ */}
                                    <div>
                                        {this.state.HtmlServiceJuristics}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="card-header" style={{ borderBottom: 'none' }}>
                                            <h5 className="card-title"><img src="dist/img/icon/ic_complaint_top03.png" className="card-icon" />คำร้อง</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row" style={{ marginBottom: 20 }}>

                                                <div className="col-sm-6 col-6">
                                                    <div className="text-center">
                                                        <h2 className="text-orange" style={{ fontWeight: 'bold', marginBottom: 0 }}>{this.state.suggestionJuristic > 0 ? `${this.state.suggestionJuristic}%` : ``}</h2>
                                                        <div className="text-orange">ข้อเสนอแนะ</div>
                                                    </div>

                                                </div>

                                                <div className="col-sm-6 col-6">
                                                    <div className="text-center">
                                                        <h2 className="text-success" style={{ fontWeight: 'bold', marginBottom: 0 }}>{this.state.serviceCenterJuristic > 0 ? `${this.state.serviceCenterJuristic}%` : ``}</h2>
                                                        <div className="text-success">แจ้งซ่อมส่วนกลาง</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-12">
                                                    <div className="relative">
                                                        {/*<canvas id="claimChart" width={500} height={300} />*/}
                                                        <Doughnut data={claimChartJuristic} options={donutOptions} width={500} height={300} />
                                                        <div className="absolute-center text-center">คำร้อง</div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="row" style={{ marginTop: 20 }}>
                                                <div className="col-sm-6 col-6">
                                                    <div className="text-center">
                                                        <div className="square-orange" />
                                                        <div className="text-orange inline">ข้อเสนอแนะ</div>
                                                    </div>
                                                </div>

                                                <div className="col-sm-6 col-6">
                                                    <div className="text-center">
                                                        <div className="square-success" />
                                                        <div className="text-success inline">แจ้งซ่อมส่วนกลาง</div>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>

                                    </div>
                                    {/* /.card-footer */}
                                </div>
                            </div>
                            ||
                            this.state.showPresale &&
                            <div className="row" >
                                <div className="col-md-6">
                                    <div className="row">

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_moreuser_01.png" className="card-icon" />ผู้เข้าใช้งานระบบ</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.systemListOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">

                                                        <div className="col-sm-12 col-12">
                                                            <div className="table-responsive">
                                                                <table className="table no-margin table-chart">
                                                                    <tbody>
                                                                        {
                                                                            this.state.systemList.slice(0, 5).map((datas, i) =>
                                                                                <tr key={i}>
                                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                                    <td colSpan={2}>{datas.display}</td>
                                                                                    <td className="text-right">{datas.value}</td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {/* /.description-block */}
                                                        </div>
                                                    </div>

                                                </div>
                                                {/* /.card-footer */}
                                            </div>
                                            {/* /.card */}
                                        </div>


                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title">
                                                        <img src="dist/img/icon/ic_complaint_top01.png" className="card-icon" />ลงทะเบียนโปรโมชั่น
                                </h5>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="description-block" style={{ margin: "30px 0" }}>
                                                                <Bar data={registerBar} options={registerOptions} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title">
                                                        <img src="dist/img/icon/ic_tips_01.png" className="card-icon" />ความสนใจ
                                </h5>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="description-block" style={{ margin: "30px 0" }}>
                                                                <Bar data={faveriteBar} options={faveriteOptions} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_moreuser_01.png" className="card-icon" />คำค้นหามากที่สุด</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.sreachOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">

                                                        <div className="col-sm-12 col-12">
                                                            <div className="table-responsive">
                                                                <table className="table no-margin table-chart" id>
                                                                    <tbody>
                                                                        {
                                                                            this.state.sreachList.slice(0, 5).map((datas, i) =>
                                                                                <tr key={i}>
                                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                                    <td colSpan={2}>{datas.display}</td>
                                                                                    <td className="text-right">{datas.value}</td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {/* /.description-block */}
                                                        </div>
                                                    </div>

                                                </div>
                                                {/* /.card-footer */}
                                            </div>
                                            {/* /.card */}
                                        </div>

                                        <div className="col-md-6" style={{ display: "none" }}>
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_location.png" className="card-icon" />Location</h5>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="description-block">
                                                                <Bar data={locationBar} options={locationOptions} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        {/* /บ้านเดี่ยว */}
                                        <div className="col-md-6">
                                            {/* /เนื้อหา */}
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title" style={{ fontSize: '25px' }}>บ้านเดี่ยว</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.singlehouseOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body" style={{ padding: 0 }}>
                                                    <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                        {this.state.singlehouseList.map((data, key) => {
                                                            return <div className="col-sm-6 col-6">
                                                                <div className="text-center">
                                                                    <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                        <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}
                                                                    </div>
                                                                </div>
                                                                {/* /.description-block */}
                                                            </div>
                                                        })
                                                        }
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="relative">
                                                                {/*<canvas id="claimChart" width={500} height={300} />*/}
                                                                <Doughnut data={claimChartSigleHouse} options={donutOptions} width={500} height={200} />
                                                                <div className="absolute-center text-center">บ้านเดี่ยว</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>

                                            </div>
                                            {/* /จบเนื้อหา */}
                                        </div>
                                        {/* /จบบ้านเดี่ยว */}

                                        {/* /ทาวโฮม */}
                                        <div className="col-md-6">
                                            {/* /เนื้อหา */}
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title" style={{ fontSize: '25px' }}>ทาวน์โฮม</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.townhomeOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body" style={{ padding: 0 }}>
                                                    <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                        {this.state.townhomeList.map((data, key) => {
                                                            return <div className="col-sm-6 col-6">
                                                                <div className="text-center">
                                                                    <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                        <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}</div>
                                                                </div>
                                                                {/* /.description-block */}
                                                            </div>
                                                        })
                                                        }
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="relative">
                                                                {/*<canvas id="claimChart" width={500} height={300} />*/}
                                                                <Doughnut data={claimCharttownhome} options={donutOptions} width={500} height={200} />
                                                                <div className="absolute-center text-center">ทาวน์โฮม</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>

                                            </div>
                                            {/* /จบเนื้อหา */}
                                        </div>
                                        {/* /ทาวโฮม */}

                                        {/* /โฮมออฟฟิศ */}
                                        <div className="col-md-6">
                                            {/* /เนื้อหา */}
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title" style={{ fontSize: '25px' }}>โฮมออฟฟิศ</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.homeofficeOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body" style={{ padding: 0 }}>
                                                    <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                        {this.state.homeofficeList.map((data, key) => {
                                                            return <div className="col-sm-6 col-6">
                                                                <div className="text-center">
                                                                    <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                        <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}</div>
                                                                </div>
                                                                {/* /.description-block */}
                                                            </div>
                                                        })
                                                        }
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="relative">
                                                                {/*<canvas id="claimChart" width={500} height={300} />*/}
                                                                <Doughnut data={claimCharthomeoffice} options={donutOptions} width={500} height={200} />
                                                                <div className="absolute-center text-center">โฮมออฟฟิศ</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>

                                            </div>
                                            {/* /จบเนื้อหา */}
                                        </div>
                                        {/* /โฮมออฟฟิศ */}

                                        {/* /คอนโด */}
                                        <div className="col-md-6">
                                            {/* /เนื้อหา */}
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title" style={{ fontSize: '25px' }}>คอนโด</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.condoOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body" style={{ padding: 0 }}>

                                                    <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                        {this.state.condoList.map((data, key) => {
                                                            return <div className="col-sm-6 col-6">
                                                                <div className="text-center">
                                                                    <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                        <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}</div>
                                                                </div>
                                                                {/* /.description-block */}
                                                            </div>
                                                        })
                                                        }
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="relative">
                                                                {/*<canvas id="claimChart" width={500} height={300} />*/}
                                                                <Doughnut data={claimChartcondo} options={donutOptions} width={500} height={200} />
                                                                <div className="absolute-center text-center">คอนโด</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />

                                                </div>

                                            </div>
                                            {/* /จบเนื้อหา */}
                                        </div>
                                        {/* /โฮมออฟฟิศ */}

                                    </div>
                                </div>
                            </div>
                            ||
                            this.state.showMember &&
                            <div className="row" >
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_moreuser_01.png" className="card-icon" />All Member</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.TotalAllMember} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">เจ้าของบ้าน</div>
                                                                <h2 className="text-highlight">{this.state.OwnerMemberCount}</h2>
                                                                <span className="text-unit">คน</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">ลูกบ้าน</div>
                                                                <h2 className="text-highlight">{this.state.LiveMemberCount}</h2>
                                                                <span className="text-unit">คน</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_tab_profile.png" className="card-icon" />Owner Member</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.OwnerMemberCount} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">โอนแล้ว</div>
                                                                <h2 className="text-highlight">{this.state.ownerMember}</h2>
                                                                <span className="text-unit">คน</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">รอโอน</div>
                                                                <h2 className="text-highlight">{this.state.installMember}</h2>
                                                                <span className="text-unit">คน</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_tab_profile.png" className="card-icon" />Install Member</h5>
                                                    <div className="card-tools">
                                                        <span>{this.state.LiveMemberCount} รายการ</span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block border-right">
                                                                <div className="description-percentage">ผู้อาศัย</div>
                                                                <h2 className="text-highlight">{this.state.liveMember}</h2>
                                                                <span className="text-unit">คน</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <div className="description-block">
                                                                <div className="description-percentage">ผู้เช่า</div>
                                                                <h2 className="text-highlight">{this.state.renterMember}</h2>
                                                                <span className="text-unit">คน</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title" style={{ fontSize: '25px' }}>Register chanel</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.memberchannelOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body" style={{ padding: 0 }}>
                                                    <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                        {this.state.memberchannelList.map((data, key) => {
                                                            return <div className="col-sm-6 col-6">
                                                                <div className="text-center">
                                                                    <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                        <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}</div>
                                                                </div>
                                                            </div>
                                                        })
                                                        }
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="relative">
                                                                <Pie data={claimChartmemberchannel} width={500} height={200} options={pieOptions} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title" style={{ fontSize: '25px' }}>Approved</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.memberapproveOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body" style={{ padding: 0 }}>
                                                    <div className="row" style={{ marginBottom: 10, display: "none" }}>

                                                        {this.state.memberapproveList.map((data, key) => {
                                                            return <div className="col-sm-6 col-6">
                                                                <div className="text-center">
                                                                    <div className="inline" style={{ fontSize: "18px", color: color[key] }}>
                                                                        <div className="square-orange" style={{ backgroundColor: color[key] }} />{data.value}% {data.display}</div>
                                                                </div>
                                                            </div>
                                                        })
                                                        }
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="relative">
                                                                <Pie data={claimChartmemberapprove} width={500} height={200} options={pieOptions} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_home_01.png" className="card-icon" />โครงการที่สมัครทั้งหมด</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.memberprojectListAllOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="table-responsive">
                                                                <table className="table no-margin table-chart">
                                                                    <tbody>
                                                                        {
                                                                            this.state.memberprojectAllList.slice(0, 5).map((datas, i) =>
                                                                                <tr key={i}>
                                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                                    <td colSpan={2}>{datas.display}</td>
                                                                                    <td className="text-right">{datas.value}</td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_home_01.png" className="card-icon" />โครงการที่สมัครที่ไม่มีนิติบุคคล</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.memberprojectListDontOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="table-responsive">
                                                                <table className="table no-margin table-chart">
                                                                    <tbody>
                                                                        {
                                                                            this.state.memberprojectDontList.slice(0, 5).map((datas, i) =>
                                                                                <tr key={i}>
                                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                                    <td colSpan={2}>{datas.display}</td>
                                                                                    <td className="text-right">{datas.value}</td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card">
                                                <div className="card-header" style={{ borderBottom: 'none' }}>
                                                    <h5 className="card-title"><img src="dist/img/icon/ic_home_01.png" className="card-icon" />โครงการที่สมัครที่มีนิติบุคคล</h5>
                                                    <div className="card-tools">
                                                        <span onClick={this.memberprojectListHaveOpen} style={{ cursor: 'Pointer' }}> อ่านทั้งหมด</span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-12">
                                                            <div className="table-responsive">
                                                                <table className="table no-margin table-chart">
                                                                    <tbody>
                                                                        {
                                                                            this.state.memberprojectHaveList.slice(0, 5).map((datas, i) =>
                                                                                <tr key={i}>
                                                                                    <td><span className="seq">{i + 1}</span></td>
                                                                                    <td colSpan={2}>{datas.display}</td>
                                                                                    <td className="text-right">{datas.value}</td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </section>

                <Modal show={this.state.systemListIsOpen} onHide={this.closeSystemList}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>ผู้เข้าใช้งานระบบ</ModalTitle>
                        <span className="text-right">รวม {this.state.systemAll} คน</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.systemList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeSystemList}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.memberprojectAllIsOpen} onHide={this.closememberprojectListAll}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>โครงการที่สมัครทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state.memberprojectAll} คน</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.memberprojectAllList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closememberprojectListAll}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.memberprojectHaveIsOpen} onHide={this.closememberprojectListHave}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>โครงการที่สมัครที่มีนิติบุคคล</ModalTitle>
                        <span className="text-right">รวม {this.state.memberprojectHave} คน</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.memberprojectHaveList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closememberprojectListHave}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.memberprojectDontIsOpen} onHide={this.closememberprojectListDont}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>โครงการที่สมัครที่ไม่มีนิติบุคคล</ModalTitle>
                        <span className="text-right">รวม {this.state.memberprojectDont} คน</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.memberprojectDontList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closememberprojectListDont}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.singlehouseIsOpen} onHide={this.closeSinglehouse}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>บ้านเดี่ยว</ModalTitle>
                        <span className="text-right">รวม {this.state.singlehouseSum}%</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.singlehouseList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}><div className="square-orange" style={{ backgroundColor: color[i] }} /> {datas.display} ({datas.count})</td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeSinglehouse}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.townhomeIsOpen} onHide={this.closeTownhome}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>ทาวน์โฮม</ModalTitle>
                        <span className="text-right">รวม {this.state.townhomeSum}%</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.townhomeList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}><div className="square-orange" style={{ backgroundColor: color[i] }} /> {datas.display} ({datas.count})</td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeTownhome}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.homeofficeIsOpen} onHide={this.closeHomeoffice}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>โฮมออฟฟิศ</ModalTitle>
                        <span className="text-right">รวม {this.state.homeofficeSum}%</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.homeofficeList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>
                                                <div className="square-orange" style={{ backgroundColor: color[i] }} />
                                                {datas.display}  ({datas.count})
                                            </td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeHomeoffice}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.condoIsOpen} onHide={this.closeCondo}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>คอนโด</ModalTitle>
                        <span className="text-right">รวม {this.state.condoSum}%</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.condoList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}><div className="square-orange" style={{ backgroundColor: color[i] }} /> {datas.display} ({datas.count})</td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeCondo}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.GroupsIsOpen} onHide={this.closeGroups}>
                    <ModalHeader style={{ border: 'none' }}>
                        {this.state.showHomecare ? <ModalTitle>เรื่องแจ้งซ่อม</ModalTitle> : <ModalTitle>เรื่องข้อเสนอแนะทั่วไป</ModalTitle>}
                        <span className="text-right">รวม {!this.state.showHomecare ? this.state.GroupsCallCenterSum : this.state.GroupsSum}%</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    (this.state.showHomecare && this.state.GroupsList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}><div className="square-orange" style={{ backgroundColor: color[i] }} /> {datas.display} ({datas.count})</td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    )) || (this.state.showCallcenter && this.state.GroupsCallCenterList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}><div className="square-orange" style={{ backgroundColor: color[i] }} /> {datas.display} ({datas.count})</td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeGroups}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.memberchannelIsOpen} onHide={this.closememberchannel}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>Member Channel</ModalTitle>
                        <span className="text-right">รวม {this.state.memberChannelSum}%</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    (this.state.memberchannelList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}><div className="square-orange" style={{ backgroundColor: color[i] }} /> {datas.display} ({datas.count})</td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closememberchannel}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.memberapproveIsOpen} onHide={this.closememberapprove}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>Member Approve</ModalTitle>
                        <span className="text-right">รวม {this.state.memberapproveSum}%</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    (this.state.memberapproveList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}><div className="square-orange" style={{ backgroundColor: color[i] }} /> {datas.display} ({datas.count})</td>
                                            <td className="text-right">{datas.value}%</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closememberapprove}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.searchIsOpen} onHide={this.closeSearch}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>คำค้นหามากที่สุด</ModalTitle>
                        <span className="text-right">รวม {this.state.sreachListSum} รายการ</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.sreachList.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeSearch}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.sugguestionIsOpen} onHide={this.closeSugguestion}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>รายการ{this.state["TextService"]}ทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state.topSuggestionAllJuristicSum}</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.topSuggestionAllJuristic.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeSugguestion}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.servicecenterIsOpen} onHide={this.closeServicecenter}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>รายการแจ้งซ่อมส่วนกลางทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state.topServiceCenterAllJuristicSum}</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.topServiceCenterAllJuristic.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeServicecenter}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.projectJuristicIsOpen} onHide={this.closeProjectJuristic}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>โครงการที่แจ้งซ่อมส่วนกลางทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state.topProjectAllJuristicSum}</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.topProjectAllJuristic.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeProjectJuristic}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.ComplaintIsOpen} onHide={this.closeComplaintCancel}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>รายการ{this.state["TextService"]}ทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state.CounttopComplaintAll}</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.topComplaintAll.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeComplaintCancel}>ปิด</button>
                    </ModalFooter>
                </Modal>

                {/* <div>
                    {this.state.HtmlService2}
                </div> */}

                <Modal show={this.state["ServiceIsOpen1"]} onHide={this.closeService}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>รายการ{this.state["TextService"]}ทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state["countTopService"]}</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state["topServiceAll"].map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeService}>ปิด</button>
                    </ModalFooter>
                </Modal>


                <Modal show={this.state.OtherIsOpen} onHide={this.closeOtherCancel}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>รายการอื่นๆ ทั้งหมด</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.topOtherAll.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeOtherCancel}>ปิด</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.ProjectIsOpen} onHide={this.closeProjectCancel}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>โครงการที่ข้อเสนอแนะทั่วไปทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state.topProjectSum}</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.topProjectAll.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeProjectCancel}>ปิด</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.ProjectIsOpen2} onHide={this.closeProjectCancel2}>
                    <ModalHeader style={{ border: 'none' }}>
                        <ModalTitle>โครงการ{this.state["TextService"]}ทั้งหมด</ModalTitle>
                        <span className="text-right">รวม {this.state.topProjectSum2}</span>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table no-margin table-chart">
                            <tbody>
                                {
                                    this.state.topProjectAll2.map((datas, i) =>
                                        <tr key={i}>
                                            <td><span className="seq">{i + 1}</span></td>
                                            <td colSpan={2}>{datas.display}</td>
                                            <td className="text-right">{datas.value}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter style={{ border: 'none' }}>
                        <button className="btn btn-danger" onClick={this.closeProjectCancel2}>ปิด</button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}